// extracted by mini-css-extract-plugin
export var content = "_p3-1";
export var fullScreen = "_p3-0";